import { useEffect, useState } from "react";
import { IProject } from "../../../../libs/types/projects";
import {
  ISocketReturn,
  TypeSockectEvent,
} from "../../../../libs/types/sockets";
import { useLoginContext } from "../context";
import DataFunctions from "../functions/database";
import ProjectsAPI from "../services/api/projects";
import { socket } from "../services/socket";

const room: TypeSockectEvent = "project_update";

const useProjectsSocket = () => {
  const [data, setData] = useState<IProject[]>([]);
  let auth = useLoginContext();

  useEffect(() => {
    getBase();
  }, []);

  useEffect(() => {
    if (socket && socket.connected) {
      socket.on(room, (io: ISocketReturn) => {
        const ioData: IProject = io.data;
        const index = data.findIndex(
          (item) =>
            new DataFunctions().getId(item) ===
            new DataFunctions().getId(ioData)
        );

        var current_data: IProject[] = [...data];

        switch (io.socketReturn) {
          case "add":
            current_data.push(ioData);
            break;

          case "update":
            if (index > -1) current_data[index] = ioData;
            break;

          case "delete":
            current_data = data.filter(
              (item) =>
                new DataFunctions().getId(item) !==
                new DataFunctions().getId(ioData)
            );
            break;
        }

        setData(current_data);
      });
    }
  }, [socket, data]);

  const getBase = async () => {
    if (auth.loginDataContext.master) {
      new ProjectsAPI().list().then(async (res) => {
        if (res.success) await setData(res.data);
      });
    } else {
      new ProjectsAPI()
        .listByUser(auth.loginDataContext.id ? auth.loginDataContext.id : "")
        .then(async (res) => {
          if (res.success) await setData(res.data);
        });
    }
  };

  return data;
};

export default useProjectsSocket;
